import { GetCurrentLoginInformationsOutput } from '@/shared/service-proxies';

const now = new Date();
now.setDate(now.getDate() + 365);

interface AbpState {
    abp: any;
    moduleKey: string;
    loginInfo: GetCurrentLoginInformationsOutput | undefined;
    tabincludes: string[];
}

const state: AbpState = {
    abp: {},
    moduleKey: '',
    loginInfo: undefined,
    tabincludes: [],
};

const getters = {
    get: (state: AbpState): any => state.abp,
    moduleKey: (state: AbpState): string => {
        if (state.moduleKey) {
            return state.moduleKey;
        }
        return abp.utils.getCookieValue('modeule-key');
    },
    getLoginInfo: (state: AbpState): any => state.loginInfo,
    tabincludes: (state: AbpState): string[] => state.tabincludes,
};

const mutations = {
    set(state: AbpState, val: any) {
        state.abp = val;
    },
    setModuleKey(state: AbpState, val: string) {
        state.moduleKey = val;
        abp.utils.setCookieValue('modeule-key', val, now, '/');
    },
    setLoginInfo(state: AbpState, val: GetCurrentLoginInformationsOutput) {
        state.loginInfo = val;
    },
    addInclude(state: AbpState, include: string) {
        if (state.tabincludes.findIndex((i) => i === include) === -1) {
            state.tabincludes.push(include);
        }
    },
    removeInclude(state: AbpState, include: string) {
        const index = state.tabincludes.findIndex((i) => i === include);
        if (index !== -1) {
            state.tabincludes.splice(index, 1);
        }
    },
    clearInclude(state: AbpState) {
        state.tabincludes = [];
    },
};

const actions = {};

const abpStore = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

export default abpStore;
